import { createAction, props } from '@ngrx/store';
import { SecurityDoc } from '../_models/securityDoc';

// Action types
export const loadSecurityDocs = createAction('[SecurityDoc] Load SecurityDocs');
export const loadSecurityDocsSuccess = createAction(
  '[SecurityDoc] Load SecurityDocs Success',
  props<{ securityDocs: SecurityDoc[] }>()
);
export const loadSecurityDocsFailure = createAction(
  '[SecurityDoc] Load SecurityDocs Failure',
  props<{ error: any }>()
);

export const addSecurityDoc = createAction(
  '[SecurityDoc] Add SecurityDoc',
  props<{ securityDoc: SecurityDoc }>()
);
export const addSecurityDocSuccess = createAction(
  '[SecurityDoc] Add SecurityDoc Success',
  props<{ securityDoc: SecurityDoc }>()
);
export const addSecurityDocFailure = createAction(
  '[SecurityDoc] Add SecurityDoc Failure',
  props<{ error: any }>()
);

export const updateSecurityDoc = createAction(
  '[SecurityDoc] Update SecurityDoc',
  props<{ securityDoc: SecurityDoc }>()
);
export const updateSecurityDocSuccess = createAction(
  '[SecurityDoc] Update SecurityDoc Success',
  props<{ securityDoc: SecurityDoc }>()
);
export const updateSecurityDocFailure = createAction(
  '[SecurityDoc] Update SecurityDoc Failure',
  props<{ error: any }>()
);

export const deleteSecurityDoc = createAction(
  '[SecurityDoc] Delete SecurityDoc',
  props<{ id: number }>()
);
export const deleteSecurityDocSuccess = createAction(
  '[SecurityDoc] Delete SecurityDoc Success',
  props<{ id: number }>()
);
export const deleteSecurityDocFailure = createAction(
  '[SecurityDoc] Delete SecurityDoc Failure',
  props<{ error: any }>()
);
